import MobileLayout from "../../../layouts/MobileLayout";

import { api } from "../../../utils/api";

import moment from "moment";

import React, { useEffect, useState, useCallback } from "react";

import "./Dashboard.css";
import DashboardHome from "../../../components/mobile/DashboardHome";
import { useAuthStore } from "../../../store/authStore";
import { useLoaderStore } from "../../../store/loaderStore";
import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";


const DashboardPage = () => {

  const navigate = useNavigate();

  // The API handler retries expired requests; token rotation must not reload the page.
  const { user, isAuthenticated } = useAuthStore();
  const companyId = user?.company_id;
  const userId = user?.user_id;
  const { showLoader, hideLoader } = useLoaderStore();

  const employeeName =
    `${user?.first_name || ""} ${user?.last_name || ""}`.trim();

  const greeting = () => {
    const hour = new Date().getHours();

    if (hour < 12) return "Good Morning";
    if (hour < 17) return "Good Afternoon";
    return "Good Evening";
  };

  const [upcomingHoliday, setUpcomingHoliday] = useState(null);
  const [shiftDetails, setShiftDetails] = useState(null);
  const [shiftLoading, setShiftLoading] = useState(true);
  const [shiftError, setShiftError] = useState(false);
  

  const [startDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );

  const [endDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD"),
  );

  const [attendanceSummary, setAttendanceSummary] = useState({
    present: 0,
    absent: 0,
    tardy: 0,
  });

  const [todayAttendance, setTodayAttendance] = useState({
    first_punch: null,
    last_punch: null,
    punch_logs: [],
  });

  const [weeklyHours, setWeeklyHours] = useState({
    total_required_hours: 0,
    total_completed_hours: 0,
    remaining_hours: 0,
  });

  const formatTime24 = (dateTime) => {
    if (!dateTime) return "-";

    return new Date(dateTime).toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const formatHours = (decimalHours) => {
    if (decimalHours === null || decimalHours === undefined) {
      return "00:00";
    }

    const totalMinutes = Math.round(Number(decimalHours) * 60);

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}`;
  };

  useEffect(() => {
    const fetchUpcomingHoliday = async () => {
      try {
        const response = await api.get(
          `/holiday/list/${user.company_id}`,
        );

        if (!response.ok) {
          throw new Error("Failed to fetch holidays");
        }

        const holidays = await response.json();

        if (Array.isArray(holidays)) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const upcoming = holidays
            .filter((holiday) => new Date(holiday.holiday_date) >= today)
            .sort(
              (a, b) => new Date(a.holiday_date) - new Date(b.holiday_date),
            )[0];

          setUpcomingHoliday(upcoming || null);
        }
      } catch (error) {
        console.error("Error fetching holidays:", error);
      }
    };

    if (user?.company_id && isAuthenticated) {
      fetchUpcomingHoliday();
    }
  }, [user?.company_id, isAuthenticated]);


//  const fetchShiftForToday = async () => {
//   try {
//     const targetDate = moment().format("YYYY-MM-DD");

//     const response = await api.get(
//       `/attendance/shift-for-date?company_id=${user.company_id}&user_id=${user.user_id}&target_date=${targetDate}`
//     );

//     const result = await response.json();

//     console.log("Today's Shift API Response:", result);

//     if (result.status) {
//       setShiftDetails(result);
//     } else {
//       setShiftDetails(null);
//     }
//   } catch (err) {
//     console.error("Shift API error:", err);
//     setShiftDetails(null);
//   }
// };


const fetchShiftForToday = async () => {
  try {
    setShiftLoading(true);
    setShiftError(false);

    const targetDate = moment().format("YYYY-MM-DD");

    const response = await api.get(
      `/attendance/shift-for-date?company_id=${user.company_id}&user_id=${user.user_id}&target_date=${targetDate}`,
    );

    const result = await response.json();

    console.log("Today's Shift API Response:", result);

    if (response.ok && result.status) {
      // Shift is actually assigned
      setShiftDetails(result);
    } else {
      // API successfully responded, but no shift is assigned
      setShiftDetails(null);
    }

  } catch (err) {
    console.error("Shift API error:", err);

    // Authentication/API error
    setShiftError(true);

    // IMPORTANT:
    // Don't treat API error as "no shift"
    setShiftDetails(null);

  } finally {
    setShiftLoading(false);
  }
};

const fetchAttendanceSummary = useCallback(async (fromDate, toDate) => {
    try {
      const response = await api.get(
        `/attendance/attendance-log?company_id=${companyId}&user_id=${userId}&from_date=${fromDate}&to_date=${toDate}`,
      );

      const result = await response.json();

      if (response.ok && result.status) {
        const data = result.data || [];

        const present = data.filter(
          (item) =>
            item.first_punch &&
            item.last_punch &&
            item.type !== "Holiday" &&
            item.type !== "Week Off" &&
            item.type !== "Leave",
        ).length;

        const absent = data.filter(
          (item) =>
            item.type === "Absent" && !item.first_punch && !item.last_punch,
        ).length;

        setAttendanceSummary({
          present,
          absent,
          tardy: 0, // update later if API provides tardy
        });
      }
    } catch (err) {
      console.error(err);

      setAttendanceSummary({
        present: 0,
        absent: 0,
        tardy: 0,
      });
    }
  }, [companyId, userId]);

  const fetchTodayAttendance = async () => {
    try {
      const response = await api.get(
        `/attendance/today?company_id=${user.company_id}&user_id=${user.user_id}`,
      );

      const result = await response.json();

      if (response.ok && result.status) {
        setTodayAttendance(result.data || {});
      } else {
        setTodayAttendance({
          first_punch: null,
          last_punch: null,
          punch_logs: [],
        });
      }
    } catch (err) {
      console.error(err);

      setTodayAttendance({
        first_punch: null,
        last_punch: null,
        punch_logs: [],
      });
    }
  };

  const fetchWeeklyHours = async () => {
    try {
      const targetDate = moment().format("YYYY-MM-DD");

      const response = await api.get(
        `/attendance/weekly-hours?company_id=${user.company_id}&user_id=${user.user_id}&target_date=${targetDate}`,
      );

      const result = await response.json();

      if (response.ok && result.status) {
        setWeeklyHours({
          total_required_hours: result.data?.total_required_hours || 0,
          total_completed_hours: result.data?.total_completed_hours || 0,
          remaining_hours: result.data?.remaining_hours || 0,
        });
      } else {
        setWeeklyHours({
          total_required_hours: 0,
          total_completed_hours: 0,
          remaining_hours: 0,
        });
      }
    } catch (err) {
      console.error("Error fetching weekly hours:", err);

      setWeeklyHours({
        total_required_hours: 0,
        total_completed_hours: 0,
        remaining_hours: 0,
      });
    }
  };

 useEffect(() => {
  const loadDashboard = async () => {
    if (!user?.company_id || !user?.user_id || !isAuthenticated) {
      return;
    }

    try {
      showLoader("master");

      await Promise.all([
        fetchTodayAttendance(),
        fetchWeeklyHours(),
        fetchShiftForToday(),
      ]);
    } finally {
      hideLoader();
    }
  };

  loadDashboard();
}, [user?.company_id, user?.user_id, isAuthenticated]);


  useEffect(() => {
    if (companyId && userId && isAuthenticated) {
      fetchAttendanceSummary(startDate, endDate);
    }
  }, [companyId, userId, isAuthenticated, startDate, endDate, fetchAttendanceSummary]);

  const punchCount = todayAttendance?.punch_logs?.length || 0;

  const punchButtonText = punchCount % 2 === 0 ? "Punch In" : "Punch Out";

//   const handlePunchClick = () => {
//   // ==========================================
//   // SHIFT NOT ASSIGNED
//   // ==========================================

//   if (
//     !shiftDetails ||
//     !shiftDetails.shift_name ||
//     !shiftDetails.shift_start_time ||
//     !shiftDetails.shift_end_time
//   ) {
//     toast.warning("Shift is not assigned for today.");
//     return;
//   }

//   // ==========================================
//   // WEEK OFF
//   // ==========================================

//   if (shiftDetails.type === "Weekoff") {
//     toast.info(
//       shiftDetails.message ||
//         "Punching is not allowed on a Week Off."
//     );
//     return;
//   }

//   // ==========================================
//   // HOLIDAY
//   // ==========================================

//   if (shiftDetails.type === "Holiday") {
//     toast.info(
//       shiftDetails.message ||
//         "Punching is not allowed on a Holiday."
//     );
//     return;
//   }

//   // ==========================================
//   // SHIFT ASSIGNED
//   // ==========================================

//   navigate("/admin/mobile/punchmark");
// };


const handlePunchClick = () => {
  // SHIFT API STILL LOADING
  if (shiftLoading) {
    return;
  }

  // SHIFT API ERROR
  if (shiftError) {
    return;
  }

  // SHIFT NOT ASSIGNED
  if (
    !shiftDetails ||
    !shiftDetails.shift_name ||
    !shiftDetails.shift_start_time ||
    !shiftDetails.shift_end_time
  ) {
    toast.warning("Shift is not assigned for today.");
    return;
  }

  // WEEK OFF
  if (shiftDetails.type === "Weekoff") {
    toast.info(
      shiftDetails.message ||
        "Punching is not allowed on a Week Off."
    );
    return;
  }

  // HOLIDAY
  if (shiftDetails.type === "Holiday") {
    toast.info(
      shiftDetails.message ||
        "Punching is not allowed on a Holiday."
    );
    return;
  }

  // SHIFT ASSIGNED
  navigate("/admin/mobile/punchmark");
};
  return (
    <MobileLayout onPunchClick={handlePunchClick} punchLabel={punchButtonText}>
      <DashboardHome
        greeting={greeting()}
        user={user}
        employeeName={employeeName}
        todayAttendance={todayAttendance}
        punchCount={punchCount}
        formatTime24={formatTime24}
        weeklyHours={weeklyHours}
        formatHours={formatHours}
        attendanceSummary={attendanceSummary}
        startDate={startDate}
        endDate={endDate}
        upcomingHoliday={upcomingHoliday}
        onHolidayClick={() => navigate("/admin/mobile/holidaylist")}
      />
    </MobileLayout>
  );
};

export default DashboardPage;
